import React, { useRef } from 'react';

import { observer } from 'mobx-react';
import classnames from 'classnames';
import { DetailedCellProps, useRowHover } from '@bringg-frontend/monitoring-shared';
import { GroupData } from '@bringg/types';

import styles from './group-row.module.scss';

const GroupRow = ({ row }: DetailedCellProps<GroupData>) => {
	const ref = useRef<HTMLDivElement>(null);

	useRowHover(ref, row.id);

	return (
		<div className={classnames(styles.row, `row-${row.id}`)} ref={ref} data-test-id={`group-row-${row.id}`}>
			<div className={styles.title}>{row.data?.title}</div>
		</div>
	);
};

export default observer(GroupRow);
